import { render, staticRenderFns } from "./WaitingListResellerInput.vue?vue&type=template&id=474045a8&scoped=true&"
import script from "./WaitingListResellerInput.vue?vue&type=script&lang=ts&"
export * from "./WaitingListResellerInput.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingListResellerInput.vue?vue&type=style&index=0&id=474045a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474045a8",
  null
  
)

export default component.exports